<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <el-dialog
                :visible.sync="showRedirectPage"
                height="60%"
                width="60%"
                :modal="true"
                :append-to-body="true"
                :show-close="false"
                :before-close="handleCloseRedirect"
            >
                <div class="iframe-container">
                    <iframe
                        :src="redirectUrl"
                        frameborder="0"
                    ></iframe>
                </div>
            </el-dialog>
            <div class="small-panel" @click.stop>
                <div class="dialog-title" v-t="'message.title_modify_credit_information'">
                </div>
                <hr class="dialog-hr">
                <div v-if="!showRedirectPage" class="dialog-body-small">
                    <div class="credit-card-box">
                        <creditcardinput ref="creditCardInput" :gmoSeverScriptPath="appData.gmoSeverScriptPath" :gmoShopId="appData.gmoShopId" currencyYen="true"
                            @on-change-input="handleChangeInput" @saveComplete="saveCardComplete" @redirect="redirect"/>
                    </div>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" @click="saveCreditCardInfo" :disabled="this.disableButton" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Vue from 'vue'
import server from "./ServerApi.js";
import commonUtil from './commonutil.js';
import constants from './constants.js';
import CreditCardInput from './CreditCardInput.vue';

export default {
    data () {
        return {
            disableButton: true,
            redirectUrl: null,
            showRedirectPage: false
        };
    },
    methods: {
        handleChangeInput(cardNumber , cardSecurityCode , cardExpire , cardHolderName , validation) {
            if (validation) {
                this.disableButton = false;
            } else {
                this.disableButton = true;
            }
        },
        saveCreditCardInfo() {
            // save credit card information.    
            this.$refs.creditCardInput.saveCreditCardInfo(null, 0);
        },
        redirect(redirectUrl) {
            this.disableButton = true
            this.redirectUrl = redirectUrl
            this.showRedirectPage = true
        },
        saveCardComplete() {
            this.$emit('save');
        },
        handleMessage(event) {
            if (event.data.tag !== 'gmoProcess') {
                return
            }

            this.showRedirectPage = false;
            if (event.data.status === 'success') {
                this.saveCardComplete()
            } else if (event.data.status === 'failure') {
                this.$emit('cancel');
            }
        },
    },
    created: function() {
    },
    mounted: function() {
        window.addEventListener('message', this.handleMessage);
    },
    beforeDestroy() {
        window.removeEventListener('message', this.handleMessage);
    },
    watch: {
    },
    components: {
        creditcardinput: CreditCardInput
    },
    props: [ 'appData' , 'tenant' , 'creditCard' ]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.credit-card-box {
    padding-top: 10px;
    padding-bottom: 10px;
    background-color: #f6f6f6;
}

.iframe-container {
    width: 100%;
    height: 90vh;
}

.iframe-container iframe {
    width: 100%;
    height: 100%;
    border: none;
}
</style>
